<template>
  <div>
    <div class="mb-1 dark:text-white">
      <span :style="textColorStyle">{{ percentage }}%</span>
      <span class="text">{{ textAbout }}</span>
    </div>
    <div class="w-full bg-gray-200 dark:bg-gray-700">
      <div class="bg-gray-500 dark:bg-gray-300" :style="progressBarStyle"></div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({
    props: {
      percentage: Number,
      textAbout: String,
      height: Number,
    },
    computed: {
      progressBarStyle() {
        return {
          width: this.percentage + '%',
          backgroundColor:
            this.percentage < 35
              ? 'red'
              : this.percentage > 36 && this.percentage < 69
              ? '#F5BE30'
              : '#30A92E',
          height: this.height + 'px',
        };
      },
      textColorStyle() {
        return {
          color:
            this.percentage < 35
              ? 'red'
              : this.percentage > 36 && this.percentage < 69
              ? '#F5BE30'
              : '#30A92E',
          fontSize: 17 + 'px',
        };
      },
    },
  });
</script>
<style>
  .text {
    font-size: 14px;
    color: #7f89a1;
    margin-left: 2px;
  }
</style>



// WEBPACK FOOTER //
// ProgressiveBar.vue?39fb515a